<template>
  <ZtPopup
    ref="popup"
    :placement="placement"
    :interactive="interactive"
    :edge-padding="edgePadding"
    :teleport="teleport"
    @open:popup="onOpen"
    @close:popup="onClose"
  >
    <slot />
    <template #content>
      <ul
        :data-test-id="testId ? `${testId}-menu` : ''"
        class="context-menu flex flex-col p-2 bg-white border shadow-lg w-max border-slate-300 dark:border-zinc-700 dark:bg-zinc-900 rounded-10"
      >
        <slot name="menu" />
      </ul>
    </template>
  </ZtPopup>
</template>
<script lang="ts" setup>
import { ref } from 'vue';
import { Placement } from '@floating-ui/vue';
import { ZtPopup } from './../popup';

import './ItemStyles.css';

withDefaults(
  defineProps<{
    testId?: string;
    interactive?: boolean;
    placement?: Placement;
    edgePadding?: number;
    teleport?: boolean;
  }>(),
  {
    interactive: false,
    placement: 'top-start',
  }
);

const popup = ref<InstanceType<typeof ZtPopup> | null>(null);
const emit = defineEmits(['isVisible', 'open', 'close']);

const closeMenu = () => popup.value?.closePopup();

defineExpose({ closeMenu });

const onOpen = () => {
  emit('open');
  emit('isVisible', true);
};

const onClose = () => {
  emit('close');
  emit('isVisible', false);
};
</script>

<style>
.context-menu li a:not(.button) {
  @apply flex items-center justify-between gap-2 px-2 py-2 text-sm font-bold rounded-sm hover:bg-slate-100 dark:hover:bg-zinc-700 active:bg-slate-300 dark:text-zinc-300 dark:hover:text-zinc-300 focus-visible:ring focus-visible:ring-blue-500/50 focus-visible:bg-blue-500/10 focus:outline-none;
}
</style>
